import React from 'react'
import ReactDOM from 'react-dom'
import {Form} from '../Form'

/**
 * Initialisation callback
 */
const woodgreenPaymentsFormInit = () => {
  // console.log('Hello from the Woodgreen Payments Form module')

  const appRootElementID = 'donation-flow'
  const appRootElement   = document.getElementById(appRootElementID)

  console.log('wgFlowConfiguration', wgFlowConfiguration)
  // console.log('wgStaticText', wgStaticText)
  // console.log('loqateKey', loqateKey)

  if (appRootElement && wgFlowConfiguration.steps && wgFlowConfiguration.expectedValues && wgFlowConfiguration.thank_you_page && wgStaticText) {

    // Fix donation issues when one type of donation is started but another is continued.
    if (localStorage && localStorage.getItem('sponsorshipData')
    && wgFlowConfiguration.expectedValues && wgFlowConfiguration.expectedValues.payment_type
    && typeof wgFlowConfiguration.expectedValues.payment_type === 'string' &&  wgFlowConfiguration.expectedValues.payment_type != '') {

      const values = JSON.parse(localStorage.getItem('sponsorshipData'));
      values.payment_type = wgFlowConfiguration.expectedValues.payment_type
      values.payment_amount = '' + wgFlowConfiguration.expectedValues.payment_amount

      // Set email campaign based on the current form.
      values.outbound = wgFlowConfiguration.expectedValues.outbound

      if (wgFlowConfiguration.steps.length <=2 ) {
        // entered into a donation form
        // no need for order_items
        values.order_items = []
      }

      localStorage.setItem('sponsorshipData', JSON.stringify(values));
    }

    ReactDOM.render(
      <Form
        giftaidRate={(typeof wgFlowConfiguration.giftaidRate === 'string') ? parseFloat(wgFlowConfiguration.giftaidRate) : wgFlowConfiguration.giftaidRate}
        donationFeeRate={(typeof wgFlowConfiguration.coverDonationFeeRate === 'string') ? parseFloat(wgFlowConfiguration.coverDonationFeeRate) : wgFlowConfiguration.coverDonationFeeRate}
        loqateKey={loqateKey.key}
        expectedValues={wgFlowConfiguration.expectedValues}
        thankYouPage={wgFlowConfiguration.thank_you_page}
        landingPage={wgFlowConfiguration.landing_page}
        staticText={wgStaticText}
        steps={wgFlowConfiguration.steps}/>,
      appRootElement
    )
  }
}

if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  woodgreenPaymentsFormInit()
} else {
  document.addEventListener("DOMContentLoaded", woodgreenPaymentsFormInit);
}
